<template>
  <div class="appointTimeBox">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconClock.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>预警设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="setTime">
      <h3 class="setTimeNext"></h3>
      <el-form ref="form" :model="form" label-width="140px">
        <div v-if="flag">
          <el-alert title="伯思立院区" type="success" :closable="false" show-icon effect="dark"></el-alert>
          <el-form-item label="9:00~11:00：">
            <el-input v-model="form.name" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
          <el-form-item label="11:00~18:00：">
            <el-input v-model="form.name1" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
          <el-form-item label="其他时间段：">
            <el-input v-model="form.name2" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
        </div>
        <div v-if="isFlag">
          <el-alert title="翡立思院区" type="success" :closable="false" show-icon effect="dark"></el-alert>
          <el-form-item label="9:00~11:00：">
            <el-input v-model="form.name3" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
          <el-form-item label="11:00~18:00：">
            <el-input v-model="form.name4" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
          <el-form-item label="其他时间段：">
            <el-input v-model="form.name5" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
        </div>
        <div v-if="show">
          <el-alert title="南通伯思立" type="success" :closable="false" show-icon effect="dark"></el-alert>
          <el-form-item label="9:00~11:00：">
            <el-input v-model="form.name6" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
          <el-form-item label="11:00~18:00：">
            <el-input v-model="form.name7" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
          <el-form-item label="其他时间段：">
            <el-input v-model="form.name8" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"></el-input>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary" @click="onSave" style="float:right;">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        name: '',
        name1: '',
        name2: '',
        name3: '',
        name4: '',
        name5: '',
        name6: '',
        name7: '',
        name8: '',
      },
      areaType: Lockr.get('areaType'),
      flag: true,
      isFlag: true,
      show: true,
    }
  },
  created() {
    this.query()
    console.log(this.areaType);
    if (this.areaType == 'bsl') {
      this.flag = true
      this.isFlag = false
      this.show = false
    } else if (this.areaType == 'fls') {
      this.flag = false
      this.show = false
      this.isFlag = true
    } else if (this.areaType == 'ntbsl') {
      this.flag = false
      this.isFlag = false
      this.show = true
    }
  },
  methods: {
    onSave() {
      let data = {
        warnList: [
          {
            id: 1,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "09:00:00",
            endDateHms: "10:59:59",
            areaCode: "bsl",
            areaName: "伯思立",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 1,
            warningNum: parseInt(this.form.name)
          },
          {
            id: 2,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "11:00:00",
            endDateHms: "17:59:59",
            areaCode: "bsl",
            areaName: "伯思立",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 2,
            warningNum: parseInt(this.form.name1)
          },
          {
            id: 3,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "18:00:00",
            endDateHms: "23:59:59",
            areaCode: "bsl",
            areaName: "伯思立",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 3,
            warningNum: parseInt(this.form.name2)
          },
          {
            id: 4,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "09:00:00",
            endDateHms: "10:59:59",
            areaCode: "fls",
            areaName: "翡立思",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 1,
            warningNum: parseInt(this.form.name3)
          },
          {
            id: 5,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "11:00:00",
            endDateHms: "17:59:59",
            areaCode: "fls",
            areaName: "翡立思",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 2,
            warningNum: parseInt(this.form.name4)
          },
          {
            id: 6,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "18:00:00",
            endDateHms: "23:59:59",
            areaCode: "fls",
            areaName: "翡立思",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 3,
            warningNum: parseInt(this.form.name5)
          },
          {
            id: 7,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "18:00:00",
            endDateHms: "23:59:59",
            areaCode: "ntbsl",
            areaName: "南通伯思立",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 3,
            warningNum: parseInt(this.form.name6)
          },
          {
            id: 8,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "18:00:00",
            endDateHms: "23:59:59",
            areaCode: "ntbsl",
            areaName: "南通伯思立",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 3,
            warningNum: parseInt(this.form.name7)
          },
          {
            id: 9,
            startDateYmd: "",
            endDateYmd: "",
            startDateHms: "18:00:00",
            endDateHms: "23:59:59",
            areaCode: "ntbsl",
            areaName: "南通伯思立",
            departmentCode: "",
            departmentName: "",
            floorCode: "",
            floorName: "",
            warningOrder: 3,
            warningNum: parseInt(this.form.name8)
          },
        ]
      }
      api.request("/warn/saveOrUpdateEarlyWarning", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "修改成功")
        } else {
          _g.toast("error", "修改失败")
        }
      }, (err) => { })
    },
    query() {
      let querys = {}
      api.requestQuiet("/warn/findEarlyWarningAll", querys, (res) => {
        console.log(res.data)
        this.form.name = res.data[0].warningNum
        this.form.name1 = res.data[1].warningNum
        this.form.name2 = res.data[2].warningNum
        this.form.name3 = res.data[3].warningNum
        this.form.name4 = res.data[4].warningNum
        this.form.name5 = res.data[5].warningNum
        this.form.name6 = res.data[6].warningNum
        this.form.name7 = res.data[7].warningNum
        this.form.name8 = res.data[8].warningNum
      }, (err) => { })
    }
  }
}
</script>
<style scoped>
.appointTimeBox >>> .el-form {
  width: 50%;
  margin: 0 auto;
  padding-top: 30px;
  box-sizing: border-box;
}
.appointTimeBox >>> .el-alert {
  margin-bottom: 20px;
}
.setTimeNext {
  margin-top: 40px;
  margin-left: 40px;
}
.appointTimeBox >>> .el-button--primary {
  width: 100%;
}
.appointTimeBox >>> .el-form-item__label {
  font-size: 18px;
  font-weight: bold;
}
.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}
</style>